import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

const allowedPrescriptions = new Set<PrescriptionPrescriptionTypeEnum>([
  PrescriptionPrescriptionTypeEnum.FreePrescription,
  PrescriptionPrescriptionTypeEnum.InsurancePrescription,
])

export const prescriptionAccessorIsInsuranceOrFree = (
  prescriptionType: PrescriptionPrescriptionTypeEnum | null,
): boolean =>
  Boolean(prescriptionType && allowedPrescriptions.has(prescriptionType))
